<template>
  <span v-if="categoryList && categoryList.length" class="categorySelect">
    <select
      class="input select inlineInput mr5"
      v-model="selectedParentId"
      @change="onParentChange">
      <option
        v-for="cate in categoryList"
        :key="cate.categoryId"
        :value="cate.categoryId">
        {{ cate.categoryLabel[defaultLang] || cate.categoryId }}
      </option>
    </select>

    <!-- 하위 카테고리가 존재하면 재귀 렌더링 -->
    <MyCollectionCategoryTree
      v-if="selectedSubCategory"
      :locale="locale"
      :collectionCategory="selectedChildId"
      :categoryList="selectedSubCategory"
      :categoryListAll="categoryListAll"
      @update="onSubCategoryChange"
    />
  </span>
</template>

<script>
export default {
  name: 'MyCollectionCategoryTree',
  props: {
    locale: Object,
    collectionCategory: String,
    categoryList: Array,
    categoryListAll: Array
  },
  components: {
    MyCollectionCategoryTree: () => import('./MyCollectionCategoryTree.vue')
  },
  data () {
    return {
      selectedParentId: '',
      selectedChildId: '',
      selectedId: ''
    }
  },
  computed: {
    defaultLang () {
      return this.$store?.state?.setting?.lang?.default || 'ko'
    },
    selectedSubCategory () {
      const selected = this.categoryList.find(c => c.categoryId === this.selectedParentId)
      return selected?.subCategory || null
    }
  },
  watch: {
    collectionCategory: {
      immediate: true,
      handler (newId) {
        this.initializeSelection(newId)
      }
    }
  },
  methods: {
    initializeSelection (targetId) {
      const findPathToId = (list, targetId, path = []) => {
        for (const item of list) {
          if (item.categoryId === targetId) return [...path, item.categoryId]
          if (item.subCategory) {
            const result = findPathToId(item.subCategory, targetId, [...path, item.categoryId])
            if (result) return result
          }
        }
        return null
      }

      const path = findPathToId(this.categoryList, targetId)
      if (path && path.length > 0) {
        this.selectedParentId = path[0]
        if (path.length > 1) {
          this.selectedChildId = path[1]
          this.selectedId = targetId
        } else {
          const parent = this.categoryList.find(c => c.categoryId === path[0])
          if (parent?.subCategory?.[0]) {
            this.selectedChildId = parent.subCategory[0].categoryId
            this.selectedId = this.selectedChildId
            this.$emit('update', this.selectedId)
          } else {
            this.selectedId = path[0]
            this.$emit('update', this.selectedId)
          }
        }
      }
    },
    onParentChange (e) {
      const newParentId = e.target.value
      this.selectedParentId = newParentId

      const parent = this.categoryList.find(c => c.categoryId === newParentId)
      if (parent?.subCategory?.[0]) {
        // 하위카테고리 존재 → 첫 번째 하위 선택
        this.selectedChildId = parent.subCategory[0].categoryId
        this.selectedId = this.selectedChildId
        this.$emit('update', this.selectedId)
      } else {
        // 하위 없음 → 현재 선택된 값 emit
        this.selectedChildId = ''
        this.selectedId = newParentId
        this.$emit('update', this.selectedId)
      }
    },
    onSubCategoryChange (childId) {
      this.selectedId = childId
      this.$emit('update', this.selectedId)
    }
  }
}
</script>

<style scoped>
.categorySelect {
  display: inline-block;
  margin-right: 8px;
}
.select {
  min-width: 120px;
}
</style>
